<template>
  <div class="c-lista-itens-pregao">
    <div class="c-lista-itens-pregao__titulo">
      {{ titulo }}
    </div>

    <v-data-table
      :headers="headers"
      :items="itensNormalizados"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :custom-sort="ordenarItens"
      :loading="loading"
      :no-data-text="textoVazio"
      :loading-text="textoCarregamento"
      class="c-lista-itens-pregao__tabela"
      disable-pagination
      hide-default-footer
      must-sort
    >
      <template #item.name="{ item }">
        <div class="d-flex align-center py-2 c-lista-itens-pregao__conteudo-coluna">
          <img
            :src="item.imageUrl"
            alt="Imagem"
            width="56"
            height="56"
            class="rounded mr-3"
            style="object-fit: cover;"
          />
          <div class="c-lista-itens-pregao__meta-wrap">
            <div class="c-lista-itens-pregao__meta c-lista-itens-pregao__meta--principal">
              {{ item.idGenericaProduto || "-" }} - {{ item.descricao_edital || "Sem descrição do item" }}
            </div>
            <div class="c-lista-itens-pregao__meta">
              {{ item.name || "-" }} | {{ obterRotuloUnidade(item.tipoUnidade) }}
            </div>
          </div>
        </div>
      </template>

      <template #item.valorCompra="{ item }">
        <div class="c-lista-itens-pregao__cell c-lista-itens-pregao__cell--numeric c-lista-itens-pregao__conteudo-coluna">
          {{ item.valorCompra | dinheiro }}
        </div>
      </template>

      <template #item.valorUnitario="{ item }">
        <div class="c-lista-itens-pregao__cell c-lista-itens-pregao__cell--numeric c-lista-itens-pregao__conteudo-coluna">
          {{ item.valorUnitario | dinheiro }}
        </div>
      </template>

      <template #item.quantidadeOriginal="{ item }">
        <div class="c-lista-itens-pregao__cell c-lista-itens-pregao__cell--numeric c-lista-itens-pregao__conteudo-coluna">
          {{ formatarQuantidade(item.quantidadeOriginal) }}
        </div>
      </template>

      <template #item.quantidadeEmpenhada="{ item }">
        <div class="c-lista-itens-pregao__cell c-lista-itens-pregao__cell--numeric c-lista-itens-pregao__conteudo-coluna">
          {{ formatarQuantidade(item.quantidadeEmpenhada) }}
        </div>
      </template>

      <template #item.quantidadeRemanescente="{ item }">
        <div class="c-lista-itens-pregao__cell c-lista-itens-pregao__cell--numeric c-lista-itens-pregao__conteudo-coluna">
          {{ formatarQuantidade(item.quantidadeRemanescente) }}
        </div>
      </template>

      <template #item.valorTotalRemanescente="{ item }">
        <div class="c-lista-itens-pregao__cell c-lista-itens-pregao__cell--numeric c-lista-itens-pregao__conteudo-coluna">
          {{ item.valorTotalRemanescente | dinheiro }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { obterRotuloTipoUnidade } from "@/utils/tiposUnidade";

export default {
  name: "listaItensPregao",
  props: {
    titulo: {
      type: String,
      default: "Itens do Pregão",
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    textoCarregamento: {
      type: String,
      default: "Carregando itens do pregão",
    },
    textoVazio: {
      type: String,
      default: "Nenhum item do pregão encontrado.",
    },
    labelQuantidadeOriginal: {
      type: String,
      default: "Qtd. Original",
    },
    labelQuantidadeEmpenhada: {
      type: String,
      default: "Qtd. Empenhada",
    },
    labelQuantidadeRemanescente: {
      type: String,
      default: "Saldo",
    },
    campoQuantidadeOriginal: {
      type: String,
      default: "",
    },
    campoQuantidadeEmpenhada: {
      type: String,
      default: "",
    },
    campoQuantidadeRemanescente: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      sortBy: "name",
      sortDesc: false,
    };
  },
  computed: {
    headers() {
      return [
        { text: "Item do Pregão", value: "name", sortable: true, width: "34%", align: "start", cellClass: "c-coluna-item-pregao", class: "c-coluna-item-pregao" },
        { text: "Vl. Compra", value: "valorCompra", sortable: true, width: "10%", align: "end", cellClass: "c-coluna-compra", class: "c-coluna-compra" },
        { text: "Vl. Venda", value: "valorUnitario", sortable: true, width: "10%", align: "end", cellClass: "c-coluna-valor", class: "c-coluna-valor" },
        { text: this.labelQuantidadeOriginal, value: "quantidadeOriginal", sortable: true, width: "11%", align: "end", cellClass: "c-coluna-quantidade-original", class: "c-coluna-quantidade-original" },
        { text: this.labelQuantidadeEmpenhada, value: "quantidadeEmpenhada", sortable: true, width: "12%", align: "end", cellClass: "c-coluna-quantidade-empenhada", class: "c-coluna-quantidade-empenhada" },
        { text: this.labelQuantidadeRemanescente, value: "quantidadeRemanescente", sortable: true, width: "9%", align: "end", cellClass: "c-coluna-quantidade", class: "c-coluna-quantidade" },
        { text: "Total", value: "valorTotalRemanescente", sortable: true, width: "14%", align: "end", cellClass: "c-coluna-total", class: "c-coluna-total" },
      ];
    },
    itensNormalizados() {
      return (this.items || []).map((item) => {
        const valorCompra = this.obterValorCompra(item);
        const valorUnitario = this.obterValorUnitario(item);
        const quantidadeOriginal = this.obterQuantidadeOriginal(item);
        const quantidadeEmpenhada = this.obterQuantidadeEmpenhada(item);
        const quantidadeRemanescente = this.obterQuantidadeRemanescente(item);

        return {
          ...item,
          idGenericaProduto: item.idGenericaProduto || item.numero_item || "-",
          descricao_edital: item.descricao_edital || "",
          tipoUnidade: item.tipoUnidade !== undefined ? item.tipoUnidade : item.tipo_unidade ?? null,
          valorCompra,
          valorUnitario,
          quantidadeOriginal,
          quantidadeEmpenhada,
          quantidadeRemanescente,
          valorTotalRemanescente: quantidadeRemanescente * valorUnitario,
        };
      });
    },
  },
  methods: {
    obterValorCompra(item) {
      return Number(item.valorDeCompra ?? item.valor_unitario_compra ?? 0) || 0;
    },
    obterValorUnitario(item) {
      return Number(item.valorProdutoPregao ?? item.valor_unitario_venda ?? 0) || 0;
    },
    obterNumeroCampo(item, campo) {
      if (!campo) return null;
      return Number(item[campo]) || 0;
    },
    obterQuantidadeOriginal(item) {
      const valorConfigurado = this.obterNumeroCampo(item, this.campoQuantidadeOriginal);
      if (valorConfigurado !== null) return valorConfigurado;

      return Number(item.quantidade ?? item.quantidade_empenhada ?? 0) || 0;
    },
    obterQuantidadeEmpenhada(item) {
      const valorConfigurado = this.obterNumeroCampo(item, this.campoQuantidadeEmpenhada);
      if (valorConfigurado !== null) return valorConfigurado;

      return Number(
        item.quantidadeEmpenhada ?? item.quantidade_empenhada ?? item.quantidades_empenhadas ?? item.quantEmpenho ?? 0
      ) || 0;
    },
    obterQuantidadeRemanescente(item) {
      const valorConfigurado = this.obterNumeroCampo(item, this.campoQuantidadeRemanescente);
      if (valorConfigurado !== null) return valorConfigurado;

      return Number(item.quantParaNota ?? item.quantidade_restante ?? 0) || 0;
    },
    obterValorOrdenacao(item, campo) {
      switch (campo) {
        case "name":
          return item.name || "";
        case "idGenericaProduto":
          return `${item.idGenericaProduto || ""} ${item.descricao_edital || ""}`.trim();
        case "tipoUnidade":
          return this.obterRotuloUnidade(item.tipoUnidade);
        default:
          return item[campo];
      }
    },
    compararValoresOrdenacao(valorA, valorB) {
      const numeroA = Number(valorA);
      const numeroB = Number(valorB);
      const ambosNumericos = !Number.isNaN(numeroA) && !Number.isNaN(numeroB);

      if (ambosNumericos) {
        return numeroA - numeroB;
      }

      return String(valorA || "").localeCompare(String(valorB || ""), "pt-BR", {
        numeric: true,
        sensitivity: "base",
      });
    },
    ordenarItens(items, sortBy, sortDesc) {
      const campos = Array.isArray(sortBy) ? sortBy : [sortBy];
      const direcoes = Array.isArray(sortDesc) ? sortDesc : [sortDesc];
      const campoAtual = campos[0] || "name";
      const descendente = !!direcoes[0];
      const itensOrdenados = [...items];

      return itensOrdenados.sort((itemA, itemB) => {
        const comparacaoPrincipal = this.compararValoresOrdenacao(
          this.obterValorOrdenacao(itemA, campoAtual),
          this.obterValorOrdenacao(itemB, campoAtual)
        );

        if (comparacaoPrincipal !== 0) {
          return descendente ? -comparacaoPrincipal : comparacaoPrincipal;
        }

        const comparacaoSecundaria = this.compararValoresOrdenacao(
          this.obterValorOrdenacao(itemA, "idGenericaProduto"),
          this.obterValorOrdenacao(itemB, "idGenericaProduto")
        );

        return descendente ? -comparacaoSecundaria : comparacaoSecundaria;
      });
    },
    formatarQuantidade(valor) {
      const numero = Number(valor) || 0;

      return numero.toLocaleString("pt-BR", {
        minimumFractionDigits: Number.isInteger(numero) ? 0 : 2,
        maximumFractionDigits: 4,
      });
    },
    obterRotuloUnidade(tipoUnidade) {
      return obterRotuloTipoUnidade(tipoUnidade);
    },
  },
};
</script>

<style>
.c-lista-itens-pregao {
  width: 1250px;
  max-width: 100%;
  margin: 28px 0 0;
}

.c-lista-itens-pregao__titulo {
  margin: 0 0 12px;
  font-size: 1rem;
  font-weight: 600;
  color: #5c5c5c;
}

.c-lista-itens-pregao__tabela table {
  width: 100%;
  table-layout: fixed;
}

.c-lista-itens-pregao__tabela tr {
  outline: solid 4px #ffffff !important;
  background: #f5f5f5;
}

.c-lista-itens-pregao__tabela td {
  padding: 18px 12px !important;
  vertical-align: middle;
}

.c-lista-itens-pregao__tabela .v-data-table__wrapper {
  width: 100%;
  border-radius: 7px;
  overflow-x: hidden;
}

.c-lista-itens-pregao__tabela thead th {
  font-size: 0.95rem !important;
  font-weight: 500 !important;
  color: #5c5c5c !important;
  white-space: nowrap;
}

.c-lista-itens-pregao__tabela thead th:nth-child(n+2) {
  text-align: right !important;
}

.c-lista-itens-pregao__tabela thead th,
.c-lista-itens-pregao__tabela tbody td {
  box-sizing: border-box;
}

.c-lista-itens-pregao__tabela thead th:first-child,
.c-lista-itens-pregao__tabela tbody td:first-child {
  padding-right: 24px !important;
}

.c-lista-itens-pregao__tabela thead th:nth-child(1),
.c-lista-itens-pregao__tabela tbody td:nth-child(1) {
  width: 34%;
}

.c-lista-itens-pregao__tabela thead th:nth-child(2),
.c-lista-itens-pregao__tabela tbody td:nth-child(2) {
  width: 10%;
}

.c-lista-itens-pregao__tabela thead th:nth-child(3),
.c-lista-itens-pregao__tabela tbody td:nth-child(3) {
  width: 10%;
}

.c-lista-itens-pregao__tabela thead th:nth-child(4),
.c-lista-itens-pregao__tabela tbody td:nth-child(4) {
  width: 11%;
}

.c-lista-itens-pregao__tabela thead th:nth-child(5),
.c-lista-itens-pregao__tabela tbody td:nth-child(5) {
  width: 12%;
}

.c-lista-itens-pregao__tabela thead th:nth-child(6),
.c-lista-itens-pregao__tabela tbody td:nth-child(6) {
  width: 9%;
}

.c-lista-itens-pregao__tabela thead th:nth-child(7),
.c-lista-itens-pregao__tabela tbody td:nth-child(7) {
  width: 14%;
}

.c-lista-itens-pregao__meta-wrap {
  min-width: 0;
}

.c-lista-itens-pregao__meta {
  margin-bottom: 0;
  font-size: 0.95rem;
  line-height: 1.35;
  color: #555;
}

.c-lista-itens-pregao__meta--principal {
  font-weight: 500;
  color: #333;
}

.c-lista-itens-pregao__cell {
  width: 100%;
  display: flex;
  align-items: center;
  color: #555;
  font-size: 0.95rem;
  line-height: 1.35;
}

.c-lista-itens-pregao__cell--numeric {
  justify-content: flex-end;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.c-lista-itens-pregao__conteudo-coluna {
  width: 100%;
}
</style>
